import {memo, useCallback} from 'react';
import type {CSSProperties, PropsWithChildren} from 'react';

import {Flex} from '../../../atoms/flex/index.js';
import {Spinner} from '../../../atoms/spinner/index.js';
import {Menu} from '../components/menu.js';
import {useMultiComboBoxContext} from '../context.js';
import {Search} from './search.js';

type SurfaceProps = {
  style?: CSSProperties;
  asChild?: boolean;
};

const SurfaceLoadingIndicator = memo(function SurfaceLoadingIndicator() {
  return (
    <Flex align="center" justify="center">
      <Spinner size={3} />
    </Flex>
  );
});
const Surface = memo(function Surface({
  style,
  children,
  asChild = false,
}: PropsWithChildren<SurfaceProps>) {
  const {isOpen, isLoading, anchorRef, closeMenu} = useMultiComboBoxContext();
  const onBlur = useCallback(() => {
    if (isOpen) {
      closeMenu();
    }
  }, [isOpen, closeMenu]);

  return (
    <Menu
      style={style}
      isHidden={!isOpen}
      anchorRef={anchorRef}
      onBlur={onBlur}
    >
      {!asChild && <Search />}
      {children}
      {isLoading && <SurfaceLoadingIndicator />}
    </Menu>
  );
});

export type {SurfaceProps};
export {Surface, SurfaceLoadingIndicator};
